import { render, staticRenderFns } from "./paymentFormComponent.vue?vue&type=template&id=260a5224&"
import script from "./paymentFormComponent.vue?vue&type=script&lang=js&"
export * from "./paymentFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./paymentFormComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "paymentFormComponent.vue"
export default component.exports